import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Deposit.css';

const DepositMethod = ({ onMethodSelect }) => {
  const navigate = useNavigate();

  const methods = [
    {
      id: 'crypto',
      title: 'Cryptocurrency (USDT)',
      description: 'Fund via USDT',
      icon: '₿'
    },
    {
      id: 'bank',
      title: 'Bank Transfer',
      description: 'Fund via bank transfers',
      icon: '🏦'
    }
  ];

  return (
    <div className="deposit-method">
      <div className="methods-grid">
        {methods.map((method) => (
          <div
            key={method.id}
            className="method-card"
            onClick={() => onMethodSelect(method.id)}
          >
            <div className="method-icon">{method.icon}</div>
            <div className="method-info">
              <h3 className="method-title">{method.title}</h3>
              <p className="method-description">{method.description}</p>
            </div>
            <div className="method-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DepositMethod;